//@flow
import React, { Component } from 'react';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { DateRangePicker, isInclusivelyAfterDay } from 'react-dates';
import moment from 'moment';
import DateOption from './DateOption';
import {
  CalendarPresetsContainerDiv,
  DisplayCalendarWrapperDiv
} from './CalendarStyles';

type Props = {
  calendarFilterState: boolean,
  toggleCalendarFilter: () => void,
  setCalendarStartFilter: (date: ?moment$Moment) => void,
  setCalendarEndFilter: (date: ?moment$Moment) => void,
  calendarStart?: string,
  calendarEnd?: string,
  windowSize: string,
  setCalendarSaga: () => void
};

type State = {
  focusedInput: string
};

class DisplayCalendar extends Component<Props, State> {
  state = {
    focusedInput: 'startDate'
  };

  componentDidUpdate(prevProps: any, prevState: State) {
    if (
      prevState.focusedInput === 'endDate' &&
      this.state.focusedInput === null
    ) {
      this.props.toggleCalendarFilter();
      this.props.setCalendarSaga();
      this.setState({ focusedInput: 'startDate' });
    }

    if (
      prevState.focusedInput === 'startDate' &&
      this.state.focusedInput === null
    ) {
      this.props.toggleCalendarFilter();
      this.setState({ focusedInput: 'startDate' });
    }
  }

  handleDatesChanged = (values: {
    startDate: ?moment$Moment,
    endDate: ?moment$Moment
  }) => {
    this.props.setCalendarStartFilter(values.startDate);
    this.props.setCalendarEndFilter(values.endDate);
    this.props.setCalendarSaga();
  };

  renderDatePresets = () => (
    <CalendarPresetsContainerDiv>
      <DateOption
        startDate={undefined}
        endDate={undefined}
        handleChange={this.handleDatesChanged}
        label="All"
      />
      <DateOption
        startDate={moment()}
        endDate={moment()}
        handleChange={this.handleDatesChanged}
        label="Today"
      />
      <DateOption
        startDate={moment().subtract(1, 'day')}
        endDate={moment().subtract(1, 'day')}
        handleChange={this.handleDatesChanged}
        label="Yesterday"
      />
      <DateOption
        startDate={moment().subtract(6, 'day')}
        endDate={moment()}
        handleChange={this.handleDatesChanged}
        label="7 Days"
      />
      <DateOption
        startDate={moment().subtract(29, 'day')}
        endDate={moment()}
        handleChange={this.handleDatesChanged}
        label="30 Days"
      />
    </CalendarPresetsContainerDiv>
  );

  render() {
    if (this.props.calendarFilterState) {
      return (
        <DisplayCalendarWrapperDiv>
          <DateRangePicker
            // startDate={moment()}
            // endDate={moment()}
            // onDatesChange={({ startDate, endDate }) =>
            //   this.setState({ startDate, endDate })
            // }
            // focusedInput={this.state.focusedInput}
            // onFocusChange={focusedInput => this.setState({ focusedInput })}
            // initialVisibleMonth={() => moment().add(2, 'M')}
            startDate={this.props.calendarStart}
            startDateId="unique_start_date_id"
            endDate={this.props.calendarEnd}
            endDateId="unique_end_date_id"
            onDatesChange={this.handleDatesChanged}
            focusedInput={this.state.focusedInput}
            onFocusChange={focusedInput => this.setState({ focusedInput })}
            noBorder
            numberOfMonths={this.props.windowSize ? 1 : 2}
            hideKeyboardShortcutsPanel
            showClearDates
            renderCalendarInfo={this.renderDatePresets}
            isOutsideRange={day => !isInclusivelyAfterDay(moment(), day)}
            minimumNights={0}
          />
        </DisplayCalendarWrapperDiv>
      );
    }
    return null;
  }
}

export default DisplayCalendar;
